import merge from 'lodash/merge';
//
import { button } from './components/button';
import { typography } from './components/typography';
import { buttonGroup } from './components/button-group';
import IconButton from './components/icon-button';
import { textField } from './components/textfield';
import { autocomplete } from './components/autocomplete';
import { checkbox } from './components/checkbox';
// import { slider } from './components/slider';
// import { radio } from './components/radio';
import { select } from './components/select';
import { card } from './components/card';
import { dialog } from './components/dialog';
import { drawer } from './components/drawer';
import { dataGrid } from './components/data-grid';
import { tabs } from './components/tabs';
import { switches } from './components/switch';
// import { menu } from './components/menu';
import { chip } from './components/chip';
import { datePicker } from './components/date-picker';
// import { pagination } from './components/pagination';
// import { paper } from './components/paper';
// import { accordion } from './components/accordion';
// ----------------------------------------------------------------------
export function componentsOverrides(theme, selectedCompany, companyTheme) {
    const components = merge(button(theme, selectedCompany, companyTheme), typography(theme), buttonGroup(theme), IconButton(theme), textField(theme), autocomplete(theme), checkbox(theme), datePicker(theme), 
    // slider(theme),
    // radio(theme),
    select(theme), card(theme), dialog(theme), drawer(theme), dataGrid(theme), tabs(theme), switches(theme), 
    // menu(theme),
    chip(theme)
    // pagination(theme),
    // paper(theme),
    // accordion(theme),
    );
    return components;
}
